import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

/**
 * Animations used by the Material datepicker.
 * @docs-private
 */
export const lcsDateTimePickerAnimations: {
   readonly transformPanel: AnimationTriggerMetadata;
   readonly fadeInCalendar: AnimationTriggerMetadata;
} = {
   /** Transforms the height of the datepicker's calendar. */
   transformPanel: trigger('transformPanel', [
      state(
         'void',
         style({
            opacity: 0,
            transform: 'scale(1, 0.8)',
         })
      ),
      transition(
         'void => enter',
         animate(
            '120ms cubic-bezier(0, 0, 0.2, 1)',
            style({
               opacity: 1,
               transform: 'scale(1, 1)',
            })
         )
      ),
      transition('* => void', animate('100ms linear', style({ opacity: 0 }))),
   ]),

   /** Fades in the content of the calendar. */
   fadeInCalendar: trigger('fadeInCalendar', [
      state('void', style({ opacity: 0 })),
      state('enter', style({ opacity: 1 })),
   ]),
};
